// Session 49 (Wave 14): the "how it works" copy on each Learn more page.
//
// Client-facing copy, DRAFTED for Leena to approve in one pass over the
// preview (decision pack 7; Standing Decisions: design, approve, then convert).
// The summary, the bullets, the benefit and the price on the same page come
// from the catalogue and were approved with it; this file holds only the part
// that says how the service works once you have it. No em dashes.
//
// Keyed by lotus_plan_groups.group_code.

export const HOW_IT_WORKS = {
  blogs: {
    heading: 'How the blog service works',
    steps: [
      'We build a quarterly plan of topics worth writing about for your business, and you approve it.',
      'Before each post we ask you a few short questions, so the writing is specific to you.',
      'You read every draft before it goes anywhere. Ask for changes, edit it yourself, or approve it.',
      'On WordPress or Astro we publish it for you. Anywhere else, you get a ready-to-post download.',
    ],
    after: 'Your first post follows within a couple of weeks of your plan being approved.',
  },
  email: {
    heading: 'How the newsletter works',
    steps: [
      'Pick one of four looks, your colours, your logo and a button that points wherever you like. Five minutes, once.',
      'Every time a blog post goes out, we make a newsletter from it in your brand: a short summary, the key points and a link to the full post.',
      'It lands under Newsletters the same day, beside the post: a PDF to read, and the same email as code.',
      'Paste the code into Mailchimp, Constant Contact or whatever you send from, and press send. Change anything you like first.',
    ],
    after: 'Once you have picked how it looks, your last two posts get a newsletter straight away, so there is something to send this week.',
    sample: true,
  },
  seo: {
    heading: 'How the SEO recommendations work',
    steps: [
      'We review how your site reads to Google and to the AI crawlers that now answer many searches.',
      'You get a checklist of fixes in priority order, in plain English, with the reason for each one.',
      'Tick them off as you make the changes on your site. We talk you through anything that is not obvious.',
      'Every quarter we review again, so the list keeps up as your site and Google both change.',
    ],
    after: 'Your first checklist is ready within a week of switching this on.',
  },
  gmb: {
    heading: 'How the Google Business Profile review works',
    steps: [
      'We go through your whole profile: categories, services, description, hours, photos and the questions people ask you.',
      'You get a step-by-step list of the specific changes that move you up in the map results, and why each one matters.',
      'Make the changes yourself from the list, or ask us to.',
      'Every quarter we look at the profile again and send you an update if there are new things to optimize.',
    ],
    after: 'We check your profile and tell you what to change to optimize it, then keep an eye on it for you.',
  },
  courses: {
    heading: 'How the course works',
    steps: [
      'Six short lessons you work through at your own pace, in the portal, on your own real work.',
      'Each lesson ends with a prompt you can copy, keep and reuse. They collect in your prompt library.',
      'Nothing to install and nothing to schedule. Stop and come back whenever you like.',
    ],
    after: 'The first lesson opens the moment this is on.',
  },
  analytics: {
    heading: 'How analytics works',
    steps: [
      'Connect your Google Analytics and Search Console once, from your setup page.',
      'Your website traffic and your Google search results appear in one place, updated nightly.',
      'When something drops sharply, you get an alert that says what moved and by how much.',
    ],
    after: 'The first numbers show the morning after you connect.',
  },
};

// The one line under a locked entry in the left rail, with the price filled
// in from the catalogue: "From $25 a month."
export function priceLine(plans) {
  const sellable = (plans || []).filter((p) => p.sellable && p.price_monthly_cents > 0);
  if (!sellable.length) return null;
  const min = Math.min(...sellable.map((p) => p.price_monthly_cents));
  const d = min / 100;
  const money = '$' + (Number.isInteger(d) ? d.toFixed(0) : d.toFixed(2));
  return sellable.length > 1 || sellable[0].requires_plan_code ? `From ${money} a month.` : `${money} a month.`;
}

// The group a rail entry belongs to in the catalogue, for the Learn more
// page. Rail keys and catalogue codes grew apart over the sessions; this is
// the one place that says which is which.
export const GROUP_FOR_ENTRY = {
  seo_blogs: 'blogs',
  newsletters: 'email',
  seo_recommendations: 'seo',
  analytics: 'analytics',
  ai_courses: 'courses',
  gmb_audit: 'gmb',
};
